import { render, staticRenderFns } from "./EngineDemo.vue?vue&type=template&id=4154a710&scoped=true"
import script from "./EngineDemo.vue?vue&type=script&lang=js"
export * from "./EngineDemo.vue?vue&type=script&lang=js"
import style0 from "./EngineDemo.vue?vue&type=style&index=0&id=4154a710&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154a710",
  null
  
)

export default component.exports